var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
            _c(
              "b-select",
              {
                attrs: {
                  placeholder: _vm.$t("pages.pickup_management.select"),
                },
                model: {
                  value: _vm.selectedGroup,
                  callback: function ($$v) {
                    _vm.selectedGroup = $$v
                  },
                  expression: "selectedGroup",
                },
              },
              [
                _vm._l(_vm.collectGroups, function (grp) {
                  return _c(
                    "option",
                    { key: grp.collectGroup, domProps: { value: grp } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            grp.collectGroup + " (" + grp.description + ")"
                          ) +
                          " "
                      ),
                    ]
                  )
                }),
                _c("option", { domProps: { value: { collectGroup: "ALL" } } }, [
                  _vm._v(" All (Warning: Lot of data) "),
                ]),
              ],
              2
            ),
            _c(
              "b-button",
              {
                staticClass: "left-right",
                attrs: {
                  tag: "router-link",
                  to: {
                    name: "closure-templates",
                    params: {
                      collect_group: _vm.selectedGroup
                        ? _vm.selectedGroup.collectGroup
                        : _vm.selectedGroup,
                    },
                  },
                  type: "is-success",
                  "icon-left": "plus",
                  disabled: !_vm.selectedGroup,
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("pages.closure_schedule.mail_template_button")
                    ) +
                    " "
                ),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "row-data": _vm.endusers,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "pagination-auto-page-size": true,
                  "side-bar": ["columns"],
                  "cache-overflow-size": 0,
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                  "get-context-menu-items": _vm.getContextMenuItems,
                },
                on: { "grid-ready": _vm.gridReady },
              }),
            ],
            1
          ),
        ]),
        _c(
          "b-modal",
          {
            attrs: {
              active: _vm.isEditingSchedule,
              scroll: "keep",
              "has-modal-card": "",
            },
            on: {
              "update:active": function ($event) {
                _vm.isEditingSchedule = $event
              },
            },
          },
          [
            _c("ScheduleForm", {
              attrs: {
                schedules: _vm.editableSchedule,
                "collect-group": _vm.selectedGroup
                  ? _vm.selectedGroup.collectGroup
                  : _vm.selectedGroup,
              },
              on: { submit: _vm.submitUpdateUser },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }